import ko from 'knockout';
import templateMarkup from 'raw-loader!./call-details-container-view.html';
import '../../../components/capture/capture';

var CAPTURE_MODAL_ID = 'AssuranceCaptureModal';

function CallDetailsContainerView(params) {

    var self = this;

    self.dataProvider = params.dataProvider;
    self.route = params.route;
    self.view = self.route().view;
    self.startTime = self.route().startTime;
    self.callId = self.route().callId;
    self.uniqueId = self.route().uniqueId;

    self.appsMenu = ko.observableArray([]);
    
    self.capturePage = function () {

        var modalEl = $('#' + CAPTURE_MODAL_ID);

        var captureModalVM = ko.dataFor(_.first(modalEl));
        captureModalVM.initialize('page', 'AssuranceCallDetails');

        modalEl.one('shown.bs.modal', function (e) {
            captureModalVM.execute();
        });

        modalEl.modal('show');
    };
}

CallDetailsContainerView.prototype.dispose = function () {
};
export default {viewModel: CallDetailsContainerView, template: templateMarkup};
